import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../ui';
import { DISTRICTS } from '../../data/districts';

// "Trusted by schools" logo wall - all districts, each links to its demo.
const TrustWall = () => (
  <section className="bg-white py-12 sm:py-16 border-b border-ink-100">
    <Container>
      <p className="text-center text-xs font-semibold uppercase tracking-widest text-brand-600 mb-1.5">
        Interactive district demos
      </p>
      <p className="text-center text-ink-500 mb-8 max-w-2xl mx-auto">
        Explore sample district portals. Tap any district to preview Valley Tickets in their colors.
        These are interactive demos, not signed customers.
      </p>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-4">
        {DISTRICTS.map((d) => {
          const initials = d.shortName ? d.shortName.slice(0, 4) : d.name.slice(0, 2).toUpperCase();
          return (
            <Link
              key={d.slug}
              to={`/demo/${d.slug}`}
              title={`${d.name} demo`}
              className="group flex items-center justify-center h-20 rounded-2xl border border-ink-100 bg-white hover:shadow-card hover:-translate-y-0.5 transition-all p-3"
            >
              {d.logo ? (
                <img src={d.logo} alt={`${d.name} logo`} loading="lazy"
                  className="max-h-12 max-w-full object-contain opacity-80 group-hover:opacity-100 transition-opacity" />
              ) : (
                <span className="font-extrabold text-lg" style={{ color: d.colors.primary }}>{initials}</span>
              )}
            </Link>
          );
        })}
      </div>
    </Container>
  </section>
);

export default TrustWall;
